const THREE = require('three/src/Three.js');
const { SphereGeometry } = require('three/src/geometries/SphereGeometry.js');
const MathUtils = require('three/src/math/MathUtils.js');

const SphereBufferGeometry = THREE.SphereBufferGeometry || SphereGeometry;
const MathNamespace = THREE.Math || MathUtils;

THREE.SphereBufferGeometry = SphereBufferGeometry;
THREE.Math = MathNamespace;

exports.__esModule = true;
exports.SphereBufferGeometry = SphereBufferGeometry;
exports.Math = MathNamespace;
exports.default = THREE;

Object.keys(THREE).forEach(key => {
	if (!(key in exports)) {
		exports[key] = THREE[key];
	}
});
